export type ScoutDeepLinkTarget = {
  id: string;
};

const ID_HASH_KEY = "id";

export const SCOUT_DEEP_LINK_SCROLL_MARGIN_TOP = 96;

export function getScoutDeepLinkTargetSx(isDeepLinkTarget: boolean) {
  return {
    scrollMarginTop: SCOUT_DEEP_LINK_SCROLL_MARGIN_TOP,
    outline: "none",
    ...(isDeepLinkTarget && {
      animation: "scoutDeepLinkPulse 1800ms ease-out 1",
    }),
    "@keyframes scoutDeepLinkPulse": {
      "0%": { backgroundColor: "rgba(25, 118, 210, 0.16)" },
      "100%": { backgroundColor: "transparent" },
    },
  };
}

function normalizeHash(hash: string): string {
  return hash.startsWith("#") ? hash.slice(1) : hash;
}

export function parseScoutDeepLinkHash(hash: string): ScoutDeepLinkTarget | undefined {
  const normalizedHash = normalizeHash(hash);
  if (!normalizedHash) {
    return undefined;
  }

  const id = new URLSearchParams(normalizedHash).get(ID_HASH_KEY)?.trim() || undefined;

  return id ? { id } : undefined;
}

export function buildScoutDeepLinkHash(target: ScoutDeepLinkTarget): string {
  const params = new URLSearchParams({ [ID_HASH_KEY]: target.id });
  return `#${params.toString()}`;
}

export function buildScoutDeepLinkUrl(input: {
  target: ScoutDeepLinkTarget;
  baseUrl?: string;
}): string {
  const hash = buildScoutDeepLinkHash(input.target);
  const fallbackBase = typeof window === "undefined" ? "" : window.location.href;
  const baseUrl = input.baseUrl ?? fallbackBase;

  if (!baseUrl) {
    return hash;
  }

  if (typeof window === "undefined") {
    return `${baseUrl.split("#")[0]}${hash}`;
  }

  const url = new URL(baseUrl, window.location.origin);
  url.hash = hash;
  return url.toString();
}
